<div class="v4-layout-content">
  <nz-tabset nzSize="large" [(nzSelectedIndex)]="tabIndex" (nzSelectedIndexChange)="onTabChange($event)">
    <nz-tab *ngFor="let item of listOfPlatforms" [nzTitle]="title">
      <ng-template #title>
        <!-- {{ (item[0] | thirdparty)?.name }}({{houseCountByThirdparty(item[0])}}) -->
        {{ (item === -1 ? "channel-house_relation-right_panel_html_全部房源" : "word.channel_" + item) | translate }}
        <!--        ({{ houseCountByThirdparty(item[0]) }})-->
      </ng-template>
      <!--      <ng-template [ngTemplateOutlet]="content" [ngTemplateOutletContext]="{ $implicit: item[0] }"></ng-template>-->
    </nz-tab>
  </nz-tabset>
  <div class="panel-content" #scrollContainer>
    <ng-container *ngIf="hasAccount; else unbindTpl">
      <div class="v4-filter-list py-[30px]" [formGroup]="form">
        <div class="v4-filter-item flex-1">
          <v4-widget-input [placeholder]="'word.search' | translate" formControlName="keyword"></v4-widget-input>
        </div>
      </div>
      <div class="list" #listContainer>
        <ng-container *ngIf="currentHouseList?.length; else empty">
          <div #node *ngFor="let house of currentHouseList; trackBy: trackById">
            <div class="v4-layout-list-item">
              <host-house-relation-house-card [houseInfo]="house">
                <div class="house-card_btns">
                  <button
                    *ngIf="isNotRecommendedConnectWay(house?.inventory); else reasonable"
                    nz-button
                    nz-tooltip
                    nzTooltipPlacement="top"
                    [nzTooltipTitle]="
                      (house?.inventory > 1
                        ? 'channel-house_relation-right_panel_html_多库存提醒'
                        : 'channel-house_relation-right_panel_html_单库存提醒'
                      ) | translate
                    "
                    (click)="onLink.emit({ node: node, data: { from: house, to: leftPanelSelectedItem } })">
                    {{ "channel-house_relation-right_panel_html_关联" | translate }}
                    <!-- Link -->
                  </button>

                  <ng-template #reasonable>
                    <button
                      nz-button
                      nzType="primary"
                      (click)="onLink.emit({ node: node, data: { from: house, to: leftPanelSelectedItem } })">
                      {{ "channel-house_relation-right_panel_html_关联" | translate }}
                      <!-- Link -->
                    </button>
                  </ng-template>
                </div>
              </host-house-relation-house-card>
            </div>
          </div>
        </ng-container>
      </div>

      <ng-template #empty>
        <div class="v4-layout-empty mt-32">
          <img class="v4-layout-empty-img" src="/assets/icon/no_data.png" />
          <div class="v4-layout-empty-content">
            <div class="v4-layout-empty-title">
              {{ "house.house_relation.no_channel_house" | translate }}
            </div>
          </div>
        </div>
      </ng-template>
    </ng-container>

    <ng-template #unbindTpl>
      <div class="v4-layout-empty mt-32 unbind-empty">
        <div class="v4-layout-empty-img"></div>
        <div class="v4-layout-empty-content">
          <div class="v4-layout-empty-title">
            {{ "channel-channel_house_html_未关联账号" | translate }}
            <!-- You haven’t connected any accounts yet -->
          </div>
        </div>
        <div class="v4-layout-empty-footer">
          <a [routerLink]="routes.ChannelAccount">
            <button nz-button nzType="primary" nzSize="large">
              {{ "channel-channel_house_html_关联账号" | translate }}
              <!-- Connect an account -->
            </button>
          </a>
        </div>
      </div>
    </ng-template>
  </div>
</div>
